import React from "react";
import locale from "@bonliva-crm/locale";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { getOptions } from "@common/CostCenterSelect";
import { MultiSelectFilter } from "./_common/multi-select-filter";
import { useCostCenters } from "@hooks";

export type AoeFilterProps = {
  label?: string;
} & FilterWithFavouriteProps;

export const CostCenterFilter = ({ label, ...props }: AoeFilterProps) => {
  const { costCenters, loading } = useCostCenters();
  const title = label ?? locale.CostCenter;

  const options = React.useMemo(() => getOptions(costCenters, true) ?? [], [costCenters]);

  return (
    <MultiSelectFilter label={title} options={options} isLoading={loading} {...props} />
  );
};
